import { render, staticRenderFns } from "./AttachmentFileItem.vue?vue&type=template&id=0fb68b87&scoped=true&"
import script from "./AttachmentFileItem.vue?vue&type=script&lang=js&"
export * from "./AttachmentFileItem.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentFileItem.vue?vue&type=style&index=0&id=0fb68b87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb68b87",
  null
  
)

export default component.exports